<div class="row" *ngIf="preview">
    <div class="col-md-6">
        <div class="card block">
            <img src="assets/widgets/ss_votre_situation.PNG"/>
        </div>
    </div>
    <div class="col-md-6">
        <div class="card block">
            <img src="assets/widgets/ss_differe.PNG"/>
        </div>
    </div>
    <div class="col-md-6">
        <div class="card block">
            <img src="assets/widgets/ss_evol_loyer_charge.PNG"/>
        </div>
    </div>
</div>

<div *ngIf="!preview">
    <div class="row"
         [stepContent]="configImpotStepContent"
         joyrideStep="configImpotStep">
        <div class="col-md-6">

            <div class="card block">
                <div class="card-header">
                    <div class="card-title">
                        <h2>Votre situation</h2>
                    </div>
                </div>
                <div class="card-body col-md-12">
                    <form [formGroup]="upgradeFormFiscal">
                        <div class="card-text row">
                            <div class="col-md-6">
                                <mat-form-field>
                                    <mat-label>Choix du régime fiscal</mat-label>
                                    <mat-select disableOptionCentering [formControlName]="'fiscal_choice_cat'"
                                                (selectionChange)="upgradeFields('fiscal_choice_cat')">
                                        <mat-option value="Foncier">Foncier</mat-option>
                                        <mat-option value="LMNP">LMNP</mat-option>
                                        <mat-option value="LMP">LMP</mat-option>
                                        <mat-option value="SCI">SCI</mat-option>
                                        <mat-option value="Societe">SASU / SAS / EURL / SARL</mat-option>
                                        <!--                                <mat-option value="SARL">SARL</mat-option>-->
                                        <mat-option value="Pinel">Pinel</mat-option>
                                        <mat-option value="Denormandie">Denormandie</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-md-6">
                                <mat-form-field>
                                    <mat-label>Option du régime fiscal</mat-label>
                                    <mat-select disableOptionCentering [formControlName]="'fiscal_choice'"
                                                (selectionChange)="upgradeFields('fiscal_choice')">
                                        <mat-option value="Foncier forfait"
                                                    *ngIf="favorite.fiscal_choice_cat == 'Foncier'">
                                            Micro foncier
                                        </mat-option>
                                        <mat-option value="Foncier reel"
                                                    *ngIf="favorite.fiscal_choice_cat == 'Foncier'">
                                            Régime réel
                                        </mat-option>
                                        <mat-option value="LMNP forfait" *ngIf="favorite.fiscal_choice_cat == 'LMNP'">
                                            Micro BIC (hors tourisme classé)
                                        </mat-option>
                                        <mat-option value="LMNP reel 2025" *ngIf="favorite.fiscal_choice_cat == 'LMNP'">
                                            Régime réel
                                        </mat-option>
<!--                                        <mat-option value="LMNP reel 2025" *ngIf="favorite.fiscal_choice_cat == 'LMNP'">-->
<!--                                            Régime réel 2025-->
<!--                                        </mat-option>-->
                                        <mat-option value="LMP - regime reel"
                                                    *ngIf="favorite.fiscal_choice_cat == 'LMP'">
                                            Régime réel
                                        </mat-option>
                                        <mat-option value="LMP - regime forfait"
                                                    *ngIf="favorite.fiscal_choice_cat == 'LMP'"
                                                    disabled>
                                            Micro BIC (Prochainement)
                                        </mat-option>
                                        <mat-option value="SCI IS" *ngIf="favorite.fiscal_choice_cat == 'SCI'">
                                            Impôt sur les sociétés
                                        </mat-option>
                                        <mat-option value="Societe IS" *ngIf="favorite.fiscal_choice_cat == 'Societe'">
                                            Impôt sur les sociétés
                                        </mat-option>
                                        <mat-option value="SCI IR" *ngIf="favorite.fiscal_choice_cat == 'SCI'">
                                            Impôt sur le revenu
                                        </mat-option>
                                        <mat-option value="Pinel - foncier reel"
                                                    *ngIf="favorite.fiscal_choice_cat == 'Pinel'">
                                            Foncier réel
                                        </mat-option>
                                        <mat-option value="Pinel - micro foncier"
                                                    *ngIf="favorite.fiscal_choice_cat == 'Pinel'">
                                            Micro foncier
                                        </mat-option>
                                        <mat-option value="Denormandie - micro foncier"
                                                    *ngIf="favorite.fiscal_choice_cat == 'Denormandie'">
                                            Micro foncier
                                        </mat-option>
                                        <mat-option value="Denormandie - foncier reel"
                                                    *ngIf="favorite.fiscal_choice_cat == 'Denormandie'">
                                            Foncier réel
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </form>
                    <div class="card-text row">
                        <div class="col-md-6"
                             *ngIf="favorite.fiscal_choice_cat == 'Pinel' || favorite.fiscal_choice_cat == 'Denormandie'">
                            <mat-form-field>
                                <mat-label>Durée d'engagement de location</mat-label>
                                <mat-select disableOptionCentering [(ngModel)]="favorite.location_engagement_duration"
                                            (ngModelChange)="edit()">
                                    <mat-option [value]="6">6</mat-option>
                                    <mat-option [value]="9">9</mat-option>
                                    <mat-option [value]="12">12</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-md-6" *ngIf="favorite.fiscal_choice_cat == 'Denormandie'">
                            <mat-form-field>
                                <mat-label>Part des travaux pour le denormandie</mat-label>
                                <input type="number" step="1000" matInput [(ngModel)]="favorite.available_work_price"
                                       (ngModelChange)="edit()">
                                <span matSuffix> €</span>
                            </mat-form-field>
                        </div>

                        <div class="col-md-6" *ngIf="favorite.fiscal_choice_cat == 'Pinel'">
                            <mat-form-field>
                                <mat-label>Année d'achat</mat-label>
                                <input type="number" step="1" matInput [(ngModel)]="favorite.buying_year"
                                       (ngModelChange)="edit()">
                            </mat-form-field>
                        </div>

                        <div class="col-md-6"
                             [hidden]="favorite.fiscal_choice == 'SCI IS' || favorite.fiscal_choice == 'Societe IS' || favorite.fiscal_choice == '' || favorite.fiscal_choice == null">
                            <mat-form-field>
                                <mat-label>Nombre de part(s)</mat-label>
                                <mat-select disableOptionCentering [(ngModel)]="favorite.shares_number"
                                            (ngModelChange)="edit()">
                                    <mat-option [value]="1">1</mat-option>
                                    <mat-option [value]="1.25">1.25</mat-option>
                                    <mat-option [value]="1.5">1.5</mat-option>
                                    <mat-option [value]="1.75">1.75</mat-option>
                                    <mat-option [value]="2">2</mat-option>
                                    <mat-option [value]="2.25">2.25</mat-option>
                                    <mat-option [value]="2.5">2.5</mat-option>
                                    <mat-option [value]="2.75">2.75</mat-option>
                                    <mat-option [value]="3">3</mat-option>
                                    <mat-option [value]="3.25">3.25</mat-option>
                                    <mat-option [value]="3.5">3.5</mat-option>
                                    <mat-option [value]="3.75">3.75</mat-option>
                                    <mat-option [value]="4">4</mat-option>
                                    <mat-option [value]="4.25">4.25</mat-option>
                                    <mat-option [value]="4.5">4.5</mat-option>
                                    <mat-option [value]="4.75">4.74</mat-option>
                                    <mat-option [value]="5">5</mat-option>
                                    <mat-option [value]="5.25">5.25</mat-option>
                                    <mat-option [value]="5.5">5.5</mat-option>
                                    <mat-option [value]="5.75">5.75</mat-option>
                                    <mat-option [value]="6">6</mat-option>
                                    <mat-option [value]="6.25">6.25</mat-option>
                                    <mat-option [value]="6.5">6.5</mat-option>
                                    <mat-option [value]="6.75">6.75</mat-option>
                                    <mat-option [value]="7">7</mat-option>
                                    <mat-option [value]="8">8</mat-option>
                                    <mat-option [value]="9">9</mat-option>
                                    <mat-option [value]="10">10</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6"
                             [hidden]="favorite.fiscal_choice == 'SCI IS' || favorite.fiscal_choice == 'Societe IS' || favorite.fiscal_choice == '' || favorite.fiscal_choice == null">
                            <mat-form-field>
                                <mat-label>Net imposable</mat-label>
                                <input type="number" step="1000" matInput [(ngModel)]="favorite.annual_income"
                                       (ngModelChange)="edit()">
                                <span matSuffix> €</span>
                                <mat-hint>(Avec foncier actuel)</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-md-12"
                             [hidden]="favorite.fiscal_choice != 'SCI IS' && favorite.fiscal_choice != 'Societe IS'">
                            <mat-form-field>
                                <mat-label>Revenus annuel
                                    <ng-container *ngIf="favorite.fiscal_choice == 'SCI IS'">SCI</ng-container>
                                    <ng-container *ngIf="favorite.fiscal_choice == 'Societe IS'">de la société
                                    </ng-container>
                                </mat-label>
                                <input type="number" step="1000" matInput [(ngModel)]="favorite.annual_income_sci"
                                       (ngModelChange)="edit()">
                                <span matSuffix> €</span>
                                <mat-hint>Revenus de la SCI avant ce projet</mat-hint>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="card block">
                <div class="card-header">
                    <div class="card-title">
                        <h2>Differé</h2>
                    </div>
                </div>
                <div class="card-body col-md-12">
                    <div class="card-text row">
                        <div class="col-md-6">
                            <mat-form-field *ngIf="authenticationService.isAllowed('expert')">
                                <mat-label>
                                    Durée du différé
                                    <i class="fa fa-question-circle" matTooltip="Un différé de crédit est une période pendant laquelle vous ne remboursez pas périodele capital de votre crédit immobilier. Vous ne payerez que les intérêts d’emprunt et l’assurance emprunteur.
La durée du différé est incluse dans la durée totale. Exemple : Si vous avez renseigné un crédit sur 20 ans avec 24 mois de différé, alors on considère 2 ans sans remboursement puis 18 ans de remboursement de crédit."></i>
                                </mat-label>
                                <input type="number" step="1" matInput [(ngModel)]="favorite.credit_differed_duration"
                                       (ngModelChange)="edit('differe')">
                                <span matSuffix> mois</span>
                            </mat-form-field>

                            <mat-form-field *ngIf="!authenticationService.isAllowed('expert')">
                                <mat-label>
                                    Durée du différé
                                    <i class="fa fa-question-circle" matTooltip="Un différé de crédit est une période pendant laquelle vous ne remboursez pas périodele capital de votre crédit immobilier. Vous ne payerez que les intérêts d’emprunt et l’assurance emprunteur.
La durée du différé est incluse dans la durée totale. Exemple : Si vous avez renseigné un crédit sur 20 ans avec 24 mois de différé, alors on considère 2 ans sans remboursement puis 18 ans de remboursement de crédit."></i>
                                </mat-label>
                                <input type="number" step="1" matInput [(ngModel)]="favorite.credit_differed_duration"
                                       (change)="upgradeFields('differe')"
                                       (keyup)="upgradeFields('differe')">
                                <span matSuffix> mois</span>
                            </mat-form-field>
                        </div>

                        <div class="col-md-6">
                            <mat-form-field *ngIf="authenticationService.isAllowed('expert')">
                                <mat-label>
                                    Différé de crédit
                                    <i class="fa fa-question-circle"
                                       matTooltip="Le différé est dit “total” si vous ne payez pas les intérêts d’emprunt pendant la durée du différé. Vous serez toujours redevable de la prime d’assurance emprunteur"></i>
                                </mat-label>
                                <mat-select disableOptionCentering [(ngModel)]="favorite.is_differed_total"
                                            (ngModelChange)="edit('is_differed_total')">
                                    <mat-option [value]="false">Différé partiel</mat-option>
                                    <mat-option [value]="true">Différé total</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <form [formGroup]="upgradeFormDiffere" *ngIf="!authenticationService.isAllowed('expert')">
                                <mat-form-field>
                                    <mat-label>
                                        Différé de crédit
                                        <i class="fa fa-question-circle"
                                           matTooltip="Le différé est dit “total” si vous ne payez pas les intérêts d’emprunt pendant la durée du différé. Vous serez toujours redevable de la prime d’assurance emprunteur"></i>
                                    </mat-label>
                                    <mat-select disableOptionCentering [formControlName]="'is_differed_total'"
                                                (selectionChange)="upgradeFields('differe')">
                                        <mat-option [value]="false">Différé partiel</mat-option>
                                        <mat-option [value]="true">Différé total</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </form>
                        </div>

                        <div class="col-md-6">
                            <mat-form-field *ngIf="authenticationService.isAllowed('expert')">
                                <mat-label>
                                    Durée des travaux
                                    <i class="fa fa-question-circle"
                                       matTooltip="Indiquez ici la durée des travaux avant mise en location de votre logement. Pendant les mois de travaux, le loyer perçu qui sera comptabilisé sera celui renseigné dans la case “Loyer pendant travaux”."></i>
                                </mat-label>
                                <input type="number" step="1" matInput [(ngModel)]="favorite.works_duration"
                                       (ngModelChange)="edit('works_duration')">
                                <span matSuffix> mois</span>
                            </mat-form-field>

                            <mat-form-field *ngIf="!authenticationService.isAllowed('expert')">
                                <mat-label>
                                    Durée des travaux
                                    <i class="fa fa-question-circle"
                                       matTooltip="Indiquez ici la durée des travaux avant mise en location de votre logement. Pendant les mois de travaux, le loyer perçu qui sera comptabilisé sera celui renseigné dans la case “Loyer pendant travaux”."></i>
                                </mat-label>
                                <input type="number" step="1" matInput [(ngModel)]="favorite.works_duration"
                                       (change)="upgradeFields('differe')"
                                       (keyup)="upgradeFields('differe')">
                                <span matSuffix> mois</span>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field *ngIf="authenticationService.isAllowed('expert')">
                                <mat-label>
                                    <i class="fa fa-question-circle"
                                       matTooltip="Indiquez le loyer que vous toucherez pendant les travaux s’il y en a. Cela peut être utile dans le cas d’un immeuble ou certains logements sont déjà loués et d’autres ont besoin de travaux avant d’être mis en location."></i>
                                    Loyer pendant travaux
                                </mat-label>
                                <input type="number" step="100" matInput [(ngModel)]="favorite.rent_before_work"
                                       (ngModelChange)="edit('rent_before_work')">
                                <span matSuffix> €</span>
                            </mat-form-field>

                            <mat-form-field *ngIf="!authenticationService.isAllowed('expert')">
                                <mat-label>
                                    <i class="fa fa-question-circle"
                                       matTooltip="Indiquez le loyer que vous toucherez pendant les travaux s’il y en a. Cela peut être utile dans le cas d’un immeuble ou certains logements sont déjà loués et d’autres ont besoin de travaux avant d’être mis en location."></i>
                                    Loyer pendant travaux
                                </mat-label>
                                <input type="number" step="100" matInput [(ngModel)]="favorite.rent_before_work"
                                       (change)="upgradeFields('differe')"
                                       (keyup)="upgradeFields('differe')">
                                <span matSuffix> €</span>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-6">
            <div class="card block">
                <div class="card-header">
                    <div class="card-title">
                        <h2>Évolution loyers & charges</h2>
                    </div>
                </div>
                <div class="card-body col-md-12">
                    <div class="card-text row">
                        <div class="col-md-6">
                            <mat-form-field>
                                <mat-label>Évolution annuelle des loyers</mat-label>
                                <input type="number" step="0.1" matInput [(ngModel)]="favorite.annual_rent_increase"
                                       (ngModelChange)="edit()">
                                <span matSuffix> %</span>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field>
                                <mat-label>Évolution annuelle des charges</mat-label>
                                <input type="number" step="0.1" matInput [(ngModel)]="favorite.annual_bill_increase"
                                       (ngModelChange)="edit()">
                                <span matSuffix> %</span>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="card block">
                <div class="card-body col-md-12">
                    <div class="card-text pt-1 pb-1">
                        <img src="assets/valide.png" class="float-left me-4" width="134" />
                        <h2 class="mt-2 mb-4">Simulations validées et certifiées !</h2>
                        <p>Les calculs et les simulations de fiscalités immobilières effectuées dans LyBox sont validés
                            et certifiées par un cabinet fiscal indépendant.</p>
                        <a (click)="openQlower()" class="text-primary text-decoration-underline cursor-pointer">Cliquez ici pour en savoir plus et bénéficier d’une remise</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 tabs tabs_full">
            <div class="tab {{favorite.selling == false ? 'active' : ''}}" (click)="toogleSelling(false)">
                SIMULATION SANS REVENTE
            </div>
            <div class="tab {{favorite.selling == true ? 'active' : ''}}" (click)="toogleSelling(true)">
                SIMULATION AVEC REVENTE
            </div>
        </div>

        <div class="col-12">
            <ng-container *ngFor="let w of warning;">
                <div class="notif notif_warning mb-4" *ngIf="w != ''">
                    <i class="fa fa-warning me-2"></i>
                    {{ w }}
                </div>
            </ng-container>
        </div>

        <div class="col-md-6" *ngIf="favorite.selling == true">
            <div class="card block">
                <div class="card-header">
                    <div class="card-title">
                        <h2>Revente</h2>
                    </div>
                </div>
                <div class="card-body col-md-12">
                    <div class="card-text row">
                        <div class="col-md-6">
                            <mat-form-field>
                                <mat-label>Revente au bout de</mat-label>
                                <input type="number" step="1" matInput [(ngModel)]="favorite.selling_year"
                                       (ngModelChange)="edit('selling_year')">
                                <span matSuffix></span>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field>
                                <mat-label>Prix net vendeur</mat-label>
                                <input type="number" step="1000" matInput [(ngModel)]="favorite.selling_price"
                                       (ngModelChange)="edit('selling_price')"
                                       [disabled]="favorite.selling_price_calc == true">
                                <span matSuffix> €</span>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6 pt-4 pb-4">
                            <mat-slide-toggle color="primary" [(ngModel)]="favorite.selling_price_calc"
                                              (ngModelChange)="edit('selling_price_calc')">
                                Appliquer un taux d’évolution annuel du prix
                            </mat-slide-toggle>
                        </div>
                        <div class="col-md-6" *ngIf="favorite.selling_price_calc">
                            <mat-form-field>
                                <mat-label>Taux d’évolution annuel</mat-label>
                                <input type="number" step="0.1" matInput [(ngModel)]="favorite.selling_price_evol"
                                       (ngModelChange)="edit('selling_price_evol')">
                                <span matSuffix> %</span>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-6" *ngIf="favorite.selling == true">
            <div class="card block">
                <div class="card-header">
                    <div class="card-title">
                        <h2>Evolution des prix dans le secteur</h2>
                    </div>
                </div>
                <div class="card-body col-md-12">
                    <div class="card-text row evol_info">
                        <p>Prix calculés sur les appartements et les maisons confondues</p>
                        <div class="col-md-4 text-center">
                            <p class="value {{ favorite.ad_city.evol_prix_ville.evol_1y != '' && favorite.ad_city.evol_prix_ville.evol_1y[0] == '-' ? 'text-danger' : 'text-success' }}">
                                <ng-container *ngIf="toFloat(favorite.ad_city.evol_prix_ville.evol_1y) > 0">+
                                </ng-container>
                                <ng-container
                                    *ngIf="favorite.ad_city.evol_prix_ville.evol_1y != ''">{{ toFloat(favorite.ad_city.evol_prix_ville.evol_1y) * 100 | number:'1.1-1' }}
                                    %
                                </ng-container>
                                <ng-container *ngIf="favorite.ad_city.evol_prix_ville.evol_1y == ''">-</ng-container>
                            </p>
                            <div class="duration">
                                Sur 1 ans
                            </div>
                            <div class="moyenne">
                                (
                                <ng-container *ngIf="toFloat(favorite.ad_city.evol_prix_ville.evol_1y) > 0">+
                                </ng-container>
                                {{ tauxAnnu(toFloat(favorite.ad_city.evol_prix_ville.evol_1y), 1) * 100 | number:'1.1-1' }}
                                %/an en moyenne)
                            </div>
                        </div>
                        <div class="col-md-4 text-center">
                            <p class="value {{ favorite.ad_city.evol_prix_ville.evol_3y != '' && favorite.ad_city.evol_prix_ville.evol_3y[0] == '-' ? 'text-danger' : 'text-success' }}">
                                <ng-container *ngIf="toFloat(favorite.ad_city.evol_prix_ville.evol_3y) > 0">+
                                </ng-container>
                                <ng-container
                                    *ngIf="favorite.ad_city.evol_prix_ville.evol_3y != ''">{{ toFloat(favorite.ad_city.evol_prix_ville.evol_3y) * 100 | number:'1.1-1' }}
                                    %
                                </ng-container>
                                <ng-container *ngIf="favorite.ad_city.evol_prix_ville.evol_3y == ''">-</ng-container>
                            </p>
                            <div class="duration">
                                Sur 3 ans
                            </div>
                            <div class="moyenne">
                                (
                                <ng-container *ngIf="toFloat(favorite.ad_city.evol_prix_ville.evol_3y) > 0">+
                                </ng-container>
                                {{ tauxAnnu(toFloat(favorite.ad_city.evol_prix_ville.evol_3y), 3) * 100 | number:'1.1-1' }}
                                %/an en moyenne)
                            </div>
                        </div>
                        <div class="col-md-4 text-center">
                            <p class="value {{ favorite.ad_city.evol_prix_ville.evol_5y != '' && favorite.ad_city.evol_prix_ville.evol_5y[0] == '-' ? 'text-danger' : 'text-success' }}">
                                <ng-container *ngIf="toFloat(favorite.ad_city.evol_prix_ville.evol_5y) > 0">+
                                </ng-container>
                                <ng-container
                                    *ngIf="favorite.ad_city.evol_prix_ville.evol_5y != ''">{{ toFloat(favorite.ad_city.evol_prix_ville.evol_5y) * 100 | number:'1.1-1' }}
                                    %
                                </ng-container>
                                <ng-container *ngIf="favorite.ad_city.evol_prix_ville.evol_5y == ''">-</ng-container>
                            </p>
                            <div class="duration">
                                Sur 5 ans
                            </div>
                            <div class="moyenne">
                                (
                                <ng-container *ngIf="toFloat(favorite.ad_city.evol_prix_ville.evol_5y) > 0">+
                                </ng-container>
                                {{ tauxAnnu(toFloat(favorite.ad_city.evol_prix_ville.evol_5y), 5) * 100 | number:'1.1-1' }}
                                %/an en moyenne)
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="card block"
         [stepContent]="evolCashFlowImpotStepContent"
         joyrideStep="evolCashFlowImpotStep">
        <div class="card-header">
            <div class="card-title">
                <h2>Évolution du Cash-Flow</h2>
            </div>
        </div>
        <div class="card-body col-md-12">
            <ng-container>
                <br>
                <div class="card-text row">
                    <ng-container *ngIf="result.length == 0 && loading == false">
                        <div class="error-page col-md-12">
                            <p>
                                <br/>
                                Veuillez remplir les informations nécessaires.<br/>
                                <br/>
                            </p>
                            <img class="img-fluid" src="assets/illustrations/undraw_settings_tab_mgiw.svg"><br/>
                        </div>
                    </ng-container>
                    <mat-spinner color="second" *ngIf="loading == true"></mat-spinner>
                    <div echarts *ngIf="result.length != 0 && loading == false" echarts [options]="options_CF"
                         class="chart"
                         (chartInit)="onChartCFInit($event)"></div>
                </div>
            </ng-container>
        </div>
    </div>

    <div class="card block isMinimizable previewBlock"
         [stepContent]="bilanComptableImpotStepContent"
         joyrideStep="bilanComptableImpotStep" id="bilanComptable">
        <div class="card-header">
            <div class="card-title">
                <i class="fa fa-angle-up"></i>
                <h2>Bilan comptable prévisionnel
                    <ng-container *ngIf="favorite.selling == true"> avec revente</ng-container>
                    <h6>
                        <mat-slide-toggle color="primary" [(ngModel)]="favorite.fiscal_detailed_view"
                                          (change)="changeView()">Affichage détaillé
                        </mat-slide-toggle>
                    </h6>
                </h2>
            </div>
        </div>
        <div class="card-body col-md-12">
            <app-upgrade-plan *ngIf="favorite.selling == true && !authenticationService.isAllowed('essentiel')"
                              plan="Essentiel" preview="assets/widgets/bilan_comptable.png"></app-upgrade-plan>
            <div class="card-text row"
                 *ngIf="favorite.selling == false || authenticationService.isAllowed('essentiel')">
                <a class="col-md-12 fullBlock" *ngIf="result.length != 0" (click)="showAll()">Tout afficher</a>
                <div class="col-md-12">
                    <ng-container *ngIf="result.length == 0 && loading == false">
                        <div class="error-page col-md-12">
                            <p>
                                <br/>
                                Veuillez remplir les informations nécessaires.<br/>
                                <br/>
                            </p>
                            <img class="img-fluid" src="assets/illustrations/undraw_settings_tab_mgiw.svg"><br/>
                        </div>
                    </ng-container>
                    <mat-spinner color="second" *ngIf="loading == true"></mat-spinner>

                    <table mat-table class="bilan_comptable" [dataSource]="result">
                        <ng-container matColumnDef="amortissement">
                            <th mat-header-cell *matHeaderCellDef> Amortissement
                            </th>
                            <td mat-cell *matCellDef="let element"> {{ element.amortissement | number: '1.0-0' }} €</td>
                        </ng-container>

                        <ng-container matColumnDef="annee">
                            <th mat-header-cell *matHeaderCellDef> Année</th>
                            <td mat-cell *matCellDef="let element"> {{ element.annee }}</td>
                        </ng-container>

                        <ng-container matColumnDef="base_imposable">
                            <th mat-header-cell *matHeaderCellDef> Base imposable
                                <i class="fa fa-question-circle" matTooltipClass="tooltip-button"
                                   matTooltipClass="tooltip-button"
                                   matTooltip="Montant sur lequel les prélèvements sociaux et les impôts sont calculés. Ce montant peut être négatif dans le cas du déficit foncier, ce qui va conduire à une économie d’impôts"></i>
                            </th>
                            <td mat-cell *matCellDef="let element"> {{ element.base_imposable | number: '1.0-0' }}€
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="base_imposable_revente">
                            <th mat-header-cell *matHeaderCellDef> Base imposable
                                <i class="fa fa-question-circle" matTooltipClass="tooltip-button"
                                   matTooltipClass="tooltip-button"
                                   matTooltip="Montant sur lequel les prélèvements sociaux et les impôts sont calculés. Ce montant peut être négatif dans le cas du déficit foncier, ce qui va conduire à une économie d’impôts"></i>
                            </th>
                            <td mat-cell
                                *matCellDef="let element"> {{ element.base_imposable_revente | number: '1.0-0' }}
                                €
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="cash_flow">
                            <th mat-header-cell *matHeaderCellDef> Cash-flow
                                <i class="fa fa-question-circle" matTooltipClass="tooltip-button"
                                   matTooltip="Cash-flow annuel de l’investissement : ce qu’il reste dans la poche après avoir récupéré les loyers, payé toute les charges et payé les impôts et prélèvements sociaux. &#013; &#10; Attention : Dans le cas d’une société, il faut rajouter l’imposition sur les dividendes pour récupérer le CF"></i>
                            </th>
                            <td mat-cell *matCellDef="let element"> {{ element.cash_flow | number: '1.0-0' }} €</td>
                        </ng-container>

                        <ng-container matColumnDef="cash_flow_revente">
                            <th mat-header-cell *matHeaderCellDef> Cash flow
                            </th>
                            <td mat-cell *matCellDef="let element"> {{ element.cash_flow_revente | number: '1.0-0' }}€
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="charges">
                            <th mat-header-cell *matHeaderCellDef> Charges
                                <i class="fa fa-question-circle" matTooltipClass="tooltip-button"
                                   matTooltip="Total des charges de l’année (gestion par agence, taxe foncière, assurance PNO, charges de copropriétés, entretien annuel, frais de relocations, frais de comptabilité, …) Attention : en année 1, les charges incluent également le montant des travaux et les frais de notaires pour certains régimes (quand ils sont déductibles directement et ne passent pas dans les amortissements)"></i>
                            </th>
                            <td mat-cell *matCellDef="let element"> {{ element.charges | number: '1.0-0' }} €</td>
                        </ng-container>

                        <ng-container matColumnDef="cumul_deficit_benefice">
                            <th mat-header-cell *matHeaderCellDef> Cumul du déficit<br/>ou bénefice
                                <i class="fa fa-question-circle" matTooltipClass="tooltip-button"
                                   matTooltip="Différence entre les revenus et les charges qui va déterminer le montant des impôts. En fonction des régimes, les travaux et les amortissements sont reportables d’années en années (dans une certaine limite). En cas de déficit, on repart avec le déficit accumulé lors des années précédentes "></i>
                            </th>
                            <td mat-cell
                                *matCellDef="let element"> {{ element.cumul_deficit_benefice | number: '1.0-0' }}
                                €
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="impot_plus_value">
                            <th mat-header-cell *matHeaderCellDef> Impôts sur<br/>la plus value
                                <i class="fa fa-question-circle" matTooltipClass="tooltip-button"
                                   matTooltip="Bientôt disponible"></i>
                            </th>
                            <td mat-cell *matCellDef="let element"> {{ element.impot_plus_value | number: '1.0-0' }}€
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="avantage_fiscal">
                            <th mat-header-cell *matHeaderCellDef> Avantage<br/>fiscal
                                <i class="fa fa-question-circle" matTooltipClass="tooltip-button"
                                   matTooltip="Bientôt disponible"></i>
                            </th>
                            <td mat-cell *matCellDef="let element"> {{ element.avantage_fiscal | number: '1.0-0' }}€
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="avantage_fiscal_revente">
                            <th mat-header-cell *matHeaderCellDef> Avantage<br/>fiscal
                                <i class="fa fa-question-circle" matTooltipClass="tooltip-button"
                                   matTooltip="Bientôt disponible"></i>
                            </th>
                            <td mat-cell
                                *matCellDef="let element"> {{ element.avantage_fiscal_revente | number: '1.0-0' }} €
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="impot_societes">
                            <th mat-header-cell *matHeaderCellDef> Impôts sur<br/>les sociétés
                                <i class="fa fa-question-circle" matTooltipClass="tooltip-button"
                                   matTooltip="Montant d’imposition que la société va payer en plus après cet investissement. Ex : si la société paye 3000€ d’impôts par an avant l’investissement et 4000€ après, la valeur de la case sera de 1000€"></i>
                            </th>
                            <td mat-cell *matCellDef="let element"> {{ element.impot_societes | number: '1.0-0' }}€
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="impot_societes_revente">
                            <th mat-header-cell *matHeaderCellDef> Impôts sur<br/>les sociétés
                            </th>
                            <td mat-cell
                                *matCellDef="let element"> {{ element.impot_societes_revente | number: '1.0-0' }}
                                €
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="impot_societes_avec_revente">
                            <th mat-header-cell *matHeaderCellDef> Impôts sur<br/>les sociétés avec revente
                                <i class="fa fa-question-circle" matTooltipClass="tooltip-button"
                                   matTooltip="Bientôt disponible"></i>
                            </th>
                            <td mat-cell
                                *matCellDef="let element"> {{ element.impot_societes_avec_revente | number: '1.0-0' }} €
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="impots_revenus">
                            <th mat-header-cell *matHeaderCellDef> Impôts sur<br/>le revenu
                                <i class="fa fa-question-circle" matTooltipClass="tooltip-button"
                                   matTooltip="Montant d’impôts sur le revenus que vous allez payer en plus après cet investissement. Ex : si vous payez 3000€ d’impôts par an avant l’investissement et 4000€ après, la valeur de la case sera de 1000€. Cela dépend de votre net imposable, de vos revenus fonciers avant l’investissement et du nombre de parts du foyer fiscal"></i>
                            </th>
                            <td mat-cell *matCellDef="let element"> {{ element.impots_revenus | number: '1.0-0' }}€
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="impots_revenus_revente">
                            <th mat-header-cell *matHeaderCellDef> Impôts sur<br/>le revenu
                                <i class="fa fa-question-circle" matTooltipClass="tooltip-button"
                                   matTooltip="Montant d’impôts sur le revenus que vous allez payer en plus après cet investissement. Ex : si vous payez 3000€ d’impôts par an avant l’investissement et 4000€ après, la valeur de la case sera de 1000€. Cela dépend de votre net imposable, de vos revenus fonciers avant l’investissement et du nombre de parts du foyer fiscal"></i>
                            </th>
                            <td mat-cell
                                *matCellDef="let element"> {{ element.impots_revenus_revente | number: '1.0-0' }}
                                €
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="prelev_sociaux">
                            <th mat-header-cell *matHeaderCellDef> Prélévements<br/>sociaux
                                <i class="fa fa-question-circle" matTooltipClass="tooltip-button"
                                   matTooltip="Montant de prélèvements sociaux à payer sur cet investissement"></i>
                            </th>
                            <td mat-cell *matCellDef="let element"> {{ element.prelev_sociaux | number: '1.0-0' }}€
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="prelev_sociaux_revente">
                            <th mat-header-cell *matHeaderCellDef> Prélévements<br/>sociaux
                                <i class="fa fa-question-circle" matTooltipClass="tooltip-button"
                                   matTooltip="Montant de prélèvements sociaux à payer sur cet investissement"></i>
                            </th>
                            <td mat-cell
                                *matCellDef="let element"> {{ element.prelev_sociaux_revente | number: '1.0-0' }}
                                €
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="loyers_percus">
                            <th mat-header-cell *matHeaderCellDef> Recettes
                                <i class="fa fa-question-circle" matTooltipClass="tooltip-button"
                                   matTooltip="Total des loyers charges comprises perçus dans l’année"></i>
                            </th>
                            <td mat-cell *matCellDef="let element"> {{ element.loyers_percus | number: '1.0-0' }} €</td>
                        </ng-container>

                        <ng-container matColumnDef="int_emprunt">
                            <th mat-header-cell *matHeaderCellDef> Intérets<br/>d'emprunt
                                <i class="fa fa-question-circle" matTooltipClass="tooltip-button"
                                   matTooltip="Total des intérêts d’emprunts sur l’année, assurance emprunteur incluse"></i>
                            </th>
                            <td mat-cell *matCellDef="let element"> {{ element.int_emprunt | number: '1.0-0' }} €</td>
                        </ng-container>

                        <ng-container matColumnDef="renta_nette_impot">
                            <th mat-header-cell *matHeaderCellDef> Rendement net<br/>d'impôts
                                <i class="fa fa-question-circle" matTooltipClass="tooltip-button"
                                   matTooltip="C’est le rendement réel de l’investissement, qui prend en compte le paiement des impôts et des prélèvements sociaux (contrairement au rendement net)"></i>
                            </th>
                            <td mat-cell
                                *matCellDef="let element"> {{ element.renta_nette_impot * 100 | number:'1.2-2' }}
                                %
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="annuite">
                            <th mat-header-cell *matHeaderCellDef> Annuité
                                <i class="fa fa-question-circle" matTooltipClass="tooltip-button"
                                   matTooltip="Correspond à 12 mensualités de crédit assurance emprunteur incluse"></i>
                            </th>
                            <td mat-cell *matCellDef="let element"> {{ element.annuite | number: '1.0-0' }} €</td>
                        </ng-container>

                        <ng-container matColumnDef="capital_restant_du">
                            <th mat-header-cell *matHeaderCellDef> Capital<br/>restant dû
                                <i class="fa fa-question-circle" matTooltipClass="tooltip-button"
                                   matTooltip="Capital restant à rembourser en fin d'année, après paiements des mensualités de l'année en cours"></i>
                            </th>
                            <td mat-cell *matCellDef="let element"> {{ element.capital_restant_du | number: '1.0-0' }}€
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="report_charge">
                            <th mat-header-cell *matHeaderCellDef> Report<br/>de charge
                            </th>
                            <td mat-cell *matCellDef="let element"> {{ element.report_charge | number: '1.0-0' }}€
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="report_charge_revente">
                            <th mat-header-cell *matHeaderCellDef> Report<br/>de charge
                            </th>
                            <td mat-cell
                                *matCellDef="let element"> {{ element.report_charge_revente | number: '1.0-0' }}€
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="stock_charges">
                            <th mat-header-cell *matHeaderCellDef> Stock<br/>de charge
                            </th>
                            <td mat-cell *matCellDef="let element"> {{ element.stock_charges | number: '1.0-0' }}€
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="stock_charges_revente">
                            <th mat-header-cell *matHeaderCellDef> Stock<br/>de charge
                            </th>
                            <td mat-cell
                                *matCellDef="let element"> {{ element.stock_charges_revente | number: '1.0-0' }}€
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="report_amortissement">
                            <th mat-header-cell *matHeaderCellDef> Report<br/>d'amortissement
                            </th>
                            <td mat-cell *matCellDef="let element"> {{ element.report_amortissement | number: '1.0-0' }}
                                €
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="report_amortissement_revente">
                            <th mat-header-cell *matHeaderCellDef> Report<br/>d'amortissement
                            </th>
                            <td mat-cell
                                *matCellDef="let element"> {{ element.report_amortissement_revente | number: '1.0-0' }}€
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="stock_amortissement">
                            <th mat-header-cell *matHeaderCellDef> Stock<br/>d'amortissement
                            </th>
                            <td mat-cell *matCellDef="let element"> {{ element.stock_amortissement | number: '1.0-0' }}€
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="stock_amortissement_revente">
                            <th mat-header-cell *matHeaderCellDef> Stock<br/>d'amortissement
                            </th>
                            <td mat-cell
                                *matCellDef="let element"> {{ element.stock_amortissement_revente | number: '1.0-0' }}€
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="cotisations_sociales">
                            <th mat-header-cell *matHeaderCellDef> Cotisations<br/>sociales
                            </th>
                            <td mat-cell *matCellDef="let element"> {{ element.cotisations_sociales | number: '1.0-0' }}
                                €
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="cotisations_sociales_revente">
                            <th mat-header-cell *matHeaderCellDef> Cotisations<br/>sociales
                            </th>
                            <td mat-cell
                                *matCellDef="let element"> {{ element.cotisations_sociales_revente | number: '1.0-0' }}€
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="prix_revente">
                            <th mat-header-cell *matHeaderCellDef> Prix de revente
                            </th>
                            <td mat-cell *matCellDef="let element"> {{ element.prix_revente | number: '1.0-0' }}€
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="treso_revente">
                            <th mat-header-cell *matHeaderCellDef> Trésorerie<br/>cumulée
                            </th>
                            <td mat-cell *matCellDef="let element"> {{ element.treso_revente | number: '1.0-0' }}€
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <div class="card block isMinimizable" *ngIf="favorite.selling == false">
        <div class="card-header">
            <div class="card-title">
                <i class="fa fa-angle-up"></i>
                <h2>Évolution de l'enrichissement<i class="fa fa-question-circle" matTooltip="Votre enrichissement annuel correspond à la somme des cash-flow de votre investissement (positif ou négatif) et du capital remboursé sur votre crédit immobilier.
Il ne prend pas en compte l’évolution du prix du bien dans le temps."></i></h2>
            </div>
        </div>
        <div class="card-body col-md-12">
            <div class="notif notif_info mb-4">
                <i class="fa fa-info-circle me-2"></i>
                Les calculs sont effectués avec le régime fiscal {{ favorite.fiscal_choice }}
            </div>
            <div class="card-text row">
                <ng-container *ngIf="result.length == 0 && loading == false">
                    <div class="error-page col-md-12">
                        <p>
                            <br/>
                            Veuillez remplir les informations nécessaires.<br/>
                            <br/>
                        </p>
                        <img class="img-fluid" src="assets/illustrations/undraw_settings_tab_mgiw.svg"><br/>
                    </div>
                </ng-container>

                <mat-spinner color="second" *ngIf="loading == true"></mat-spinner>
                <div echarts *ngIf="result.length != 0 && loading == false" [options]="options_Evol_Capital"
                     class="chart" (chartInit)="onChartECInit($event)"></div>
            </div>
        </div>
    </div>

    <div class="card block isMinimizable">
        <div class="card-header">
            <div class="card-title">
                <i class="fa fa-angle-up"></i>
                <h2>Évolution de trésorerie
                    <ng-container *ngIf="favorite.selling == true"> avec revente</ng-container>
                    <i class="fa fa-info-circle me-2 fs-7 ms-2" matTooltip="Ce graphique vous montre combien d’argent vous rapporte (ou coûte) votre projet année après année pour chaque régime fiscal.
Pendant que vous êtes propriétaire, cela correspond au cumul de votre cash-flow.
L’année de la revente, vous récupérerez le prix de revente après avoir remboursé votre crédit et payé vos impôts sur la plus-value.

Attention : Pour la SCI à l’IS, l’argent est sur le compte de la société. La prise de dividendes et la flat tax ne sont pas comptabilisés.
"></i>
                </h2>
            </div>
        </div>
        <div class="card-body col-md-12">
            <app-upgrade-plan *ngIf="favorite.selling == true && !authenticationService.isAllowed('essentiel')"
                              plan="Essentiel" preview="assets/widgets/evol_treso.png"></app-upgrade-plan>
            <ng-container *ngIf="favorite.selling == false || authenticationService.isAllowed('essentiel')">
                <div class="notif notif_info mb-4" *ngIf="favorite.selling == true">
                    <i class="fa fa-info-circle me-2"></i>
                    Les calculs sont effectués en prenant en compte une revente au bout de {{ favorite.selling_year }}
                    ans
                    au prix de {{ favorite.selling_price | number : '1.0-0' }} €
                </div>
                <div class="card-text row">
                    <ng-container *ngIf="result.length == 0 && loading == false">
                        <div class="error-page col-md-12">
                            <p>
                                <br/>
                                Veuillez remplir les informations nécessaires.<br/>
                                <br/>
                            </p>
                            <img class="img-fluid" src="assets/illustrations/undraw_settings_tab_mgiw.svg"><br/>
                        </div>
                    </ng-container>
                    <mat-spinner color="second" *ngIf="loading == true"></mat-spinner>
                    <div echarts *ngIf="result.length != 0 && loading == false" [options]="options_Comp_Treso"
                         class="chart"
                         (chartInit)="onChartCTInit($event)"></div>
                </div>
            </ng-container>
        </div>
    </div>

    <div *ngIf="favorite.selling == true"
         class="card block isMinimizable">
        <div class="card-header">
            <div class="card-title">
                <i class="fa fa-angle-up"></i>
                <h2>Comparaison des régimes fiscaux</h2>
            </div>
        </div>
        <div class="card-body col-md-12">
            <app-upgrade-plan *ngIf="!authenticationService.isAllowed('essentiel')"
                              plan="Essentiel" preview="assets/widgets/comparatif_fiscal.png"></app-upgrade-plan>
            <ng-container *ngIf="authenticationService.isAllowed('essentiel')">
                <h5>Les calculs sont effectués en prenant en compte une revente au bout de {{ favorite.selling_year }}
                    ans
                    au prix de {{ favorite.selling_price | number : '1.0-0' }} € </h5>
                <br>
                <div class="card-text row">
                    <ng-container *ngIf="result.length == 0 && loading == false">
                        <div class="error-page col-md-12">
                            <p>
                                <br/>
                                Veuillez remplir les informations nécessaires.<br/>
                                <br/>
                            </p>
                            <img class="img-fluid" src="assets/illustrations/undraw_settings_tab_mgiw.svg"><br/>
                        </div>
                    </ng-container>
                    <mat-spinner color="second" *ngIf="loading == true"></mat-spinner>
                    <div echarts *ngIf="result.length != 0 && loading == false" echarts [options]="options"
                         class="chartCmp"
                         (chartInit)="onChartInit($event)"></div>
                    <div class="col-11" style="margin-top: -40px; z-index: 100">
                        <div class="row">
                            <div class="col-4 text-center">
                                Enrichissement
                                <i class="fa fa-question-circle" matTooltip="L’enrichissement vous donne l’argent total que vous avez gagné grâce à cet investissement une fois qu’il est revendu.
C’est ce qu’il vous restera une fois le bien revendu, le crédit remboursé, l’impôt sur la plus-value payé (ou impôt sur les sociétés), et votre apport récupéré.
Cela prend aussi en compte le cash-flow cumulé (positif ou négatif) pendant les années ou vous étiez propriétaire."></i>
                            </div>
                            <div class="col-4 text-center">
                                Valeur Actuelle Nette
                                <i class="fa fa-question-circle"
                                   matTooltip="La VAN (Valeur Actuelle Nette) vous permet de voir le gain généré par votre investissement locatif par rapport à un placement de référence à 3%/an."></i>
                            </div>
                            <div class="col-4 text-center">
                                Taux de Rendement Interne
                                <i class="fa fa-question-circle" matTooltip="Le TRI (Taux de Rendement Interne) est le taux de rendement final de l’opération, avec prise en compte de la revente.
Il s’interprète comme le taux annuel moyen de rendement de votre apport grâce à cet investissement.
Attention : Si l’apport est très faible, le TRI n’est pas la bonne mesure de performance à utiliser."></i>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
<ng-template #configImpotStepContent>
    <div class="user_onboarding_content">
        <h2>Les paramètres de votre simulation</h2>
        <p>
            Nous y sommes ! Vous pouvez renseigner le régime fiscal de votre choix, ainsi que les informations sur votre
            situation personnelle.<br/>
            <br/>
            Le simulateur va ensuite calculer un <b>bilan comptable sur 30 ans</b> de votre investissement.<br/>
            <br/>
            <b>Astuce</b> : Vous pouvez paramétrer une revente, des évolutions de loyers ainsi qu’un différé de
            crédit.
        </p>
    </div>
</ng-template>


<ng-template #evolCashFlowImpotStepContent>
    <div class="user_onboarding_content">
        <h2>Votre cash-flow futur</h2>
        <p>
            La magie opère !<br/>
            <br/>
            <b>Voici l’évolution dans le temps de votre cash-flow</b>, en fonction de votre loyer, de votre crédit, de
            vos impôts et de vos charges.<br/>
            <br/>
            Alors, <b>rentable cet investissement ?</b>
        </p>
    </div>
</ng-template>

<ng-template #bilanComptableImpotStepContent>
    <div class="user_onboarding_content">
        <h2>Votre bilan comptable</h2>
        <p>
            Vous pouvez rentrer dans le détail des chiffres année après année grâce à ce <b>bilan comptable</b>.<br/>
            <br/>
            Grâce à ce tableau, vous savez à partir de quelle année vous allez commencer à payer des impôts, et combien.<br/>
            <br/>
            Attention, ce tableau ne prend pas en compte la <b>revente</b><br/>
            <br/>
            <b>Astuce</b> : Les prochains graphiques vous permettront d’analyser la revente et de comparer les régimes
            fiscaux entre eux. N’hésitez pas à regarder nos tutoriels vidéo (menu de gauche) pour en savoir plus 🙂
        </p>
    </div>
</ng-template>
